module.exports = __webpack_public_path__ + "img/whatsapp.a2c5db8b.png";